/** Bildirim güvenlik bağlamı — Firestore rules ile eşleşir */
export const NOTIFICATION_CONTEXT = {
  INSTRUCTOR_TO_STUDENT: 'instructor_to_student',
  STUDENT_TO_INSTRUCTOR: 'student_to_instructor',
};

export const instructorToStudentContext = (studentId) => ({
  type: NOTIFICATION_CONTEXT.INSTRUCTOR_TO_STUDENT,
  studentId,
});

export const studentToInstructorContext = (studentId, instructorId) => ({
  type: NOTIFICATION_CONTEXT.STUDENT_TO_INSTRUCTOR,
  studentId,
  instructorId,
});
